(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-header"] && !Shopify.designMode) return;
  try {
    
  /* Read more / Read less for long collection descriptions.
     The limit is N lines of body copy measured from the first paragraph,
     so any eyebrow / heading / mark the description starts with is never
     counted against it. Clamp is applied only when the copy actually
     overflows, so short descriptions never show a stray toggle. */
  (function () {
    var sections = document.querySelectorAll('.custom-ch');
    sections.forEach(function (section) {
      var desc = section.querySelector('[data-custom-ch-desc]');
      var btn = section.querySelector('[data-custom-ch-more]');
      if (!desc || !btn) return;
      var more = btn.querySelector('[data-more]');
      var less = btn.querySelector('[data-less]');
      var lines = parseInt(getComputedStyle(section).getPropertyValue('--custom-ch-clamp'), 10) || 0;
      if (!lines) return;

      /* A one-line bold paragraph ("<p><strong>About FRED</strong></p>") is a
         heading typed in the old editor, not body copy. */
      function isBoldLine(el) {
        var b = el.querySelector('strong, b');
        return !!b && (b.textContent || '').trim() === (el.textContent || '').trim();
      }

      function firstParagraph() {
        var kids = desc.querySelectorAll('*');
        for (var i = 0; i < kids.length; i++) {
          var el = kids[i];
          if (/^H[1-6]$/.test(el.tagName) || el.querySelector('img, .custom-ch__hmark')) continue;
          if (el.closest('h1, h2, h3, h4, h5, h6, .custom-ch__hmark')) continue;
          if (/^(STRONG|B)$/.test(el.tagName) || isBoldLine(el)) continue;
          if ((el.textContent || '').trim()) return el;
        }
        return desc;
      }

      function measure() {
        if (btn.getAttribute('aria-expanded') === 'true') return;
        desc.style.maxHeight = '';
        desc.removeAttribute('data-clamped');
        var p = firstParagraph();
        var cs = getComputedStyle(p);
        var lh = parseFloat(cs.lineHeight) || parseFloat(cs.fontSize) * 1.5;
        var top = p.getBoundingClientRect().top - desc.getBoundingClientRect().top;
        var limit = Math.round(top + lh * lines);
        var overflows = desc.scrollHeight > limit + 4;
        btn.hidden = !overflows;
        if (overflows) {
          desc.style.maxHeight = limit + 'px';
          desc.setAttribute('data-clamped', '');
        }
      }

      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        if (open) {
          btn.setAttribute('aria-expanded', 'false');
          more.hidden = false; less.hidden = true;
          measure();
        } else {
          desc.style.maxHeight = '';
          desc.removeAttribute('data-clamped');
          btn.setAttribute('aria-expanded', 'true');
          more.hidden = true; less.hidden = false;
        }
      });

      measure();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
      /* A logo or mark above the copy can finish loading after the first
         measurement and push the text down; re-measure when it does. */
      desc.querySelectorAll('img').forEach(function (img) {
        if (!img.complete) img.addEventListener('load', measure, { once: true });
      });
      window.addEventListener('load', measure, { once: true });
      var t;
      window.addEventListener('resize', function () {
        clearTimeout(t); t = setTimeout(measure, 150);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
